import { useEffect, useState } from 'react';
import authService, { type SignInProvider } from '../services/auth.service';

/**
 * The ways to sign in besides email and password that this environment offers,
 * in display order. Empty until the list arrives, and it stays empty when the
 * list cannot be read — the pages that use it then render nothing extra, so a
 * failed list never stands between a person and the password form.
 */
export function useSignInProviders(): SignInProvider[] {
  const [providers, setProviders] = useState<SignInProvider[]>([]);

  useEffect(() => {
    let cancelled = false;
    // `listSignInProviders` resolves to [] on any failure; it never rejects.
    authService.listSignInProviders().then((list) => {
      if (!cancelled) setProviders(list);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return providers;
}
